import { withTheme } from '@emotion/react';
import React from 'react';
import { TestId } from '@components/test-ids';
import { Theme } from '@theme/base';
import Link from 'next/link';
import { useI18NextContext } from '@components/hooks';
import { Page } from '@model/common/pages';
import { HelpLink } from '@components/common/next-link';
import { PageData } from '@model/content';
import { NavContainer, NavHeading, NavItem, LinksListContainer } from './styles';
import { AppVariant } from '@model/config/brands';

/* ***************** *
 *       Types       *
 * ***************** */
export interface HereToHelpNavContentProps {
  theme?: Theme;
  testId?: string;
  infoPages: Array<PageData>;
  onToggleDesktopNav?: () => void;
}

/* *********************************** *
 *    HereToHelpNavContentComponent    *
 * *********************************** */

export const HereToHelpNavContentComponent = (props: HereToHelpNavContentProps) => {
  const { onToggleDesktopNav, infoPages } = props;
  const t: any = useI18NextContext();
  const isWhiteLabel = AppVariant.isWhitelabel();

  if (!infoPages) {
    return null;
  }

  const renderLinks = () =>
    infoPages.map(({ path, name }: PageData) => (
      <NavItem onClick={onToggleDesktopNav} key={path}>
        <HelpLink path={'/'.concat(path)}>{name}</HelpLink>
      </NavItem>
    ));
  return (
    <NavContainer data-testid={props.testId || TestId.hereToHelpNavContent.main}>
      <NavHeading>
        {t('nav__here-to-help')}{' '}
        <span>
          (
          <Link prefetch={false} href={Page.HELP}>
            {t('nav__label--view-all')}
          </Link>
          )
        </span>
      </NavHeading>
      <LinksListContainer displayInColumns={infoPages.length > 4}>
        {renderLinks()}
        {!isWhiteLabel && (
          <NavItem onClick={onToggleDesktopNav}>
            <Link href={Page.AGENTS}>{t('agent__link--title')}</Link>
          </NavItem>
        )}
      </LinksListContainer>
    </NavContainer>
  );
};

export const HereToHelpNavContent = withTheme(HereToHelpNavContentComponent);
